import * as React from "react";
import { Text, View } from "react-native";
import { Image as ExpoImage, ImageProps } from "expo-image";
import { Feather } from "@expo/vector-icons";

export function Image(props: Omit<ImageProps, "source"> & { source?: string }) {
  const [error, setError] = React.useState(false);

  if (error || !props.source) {
    return (
      <View style={props.style} className="items-center justify-center">
        <View className="items-center ">
          <Feather
            name="alert-triangle"
            size={24}
            className="text-text-secondary"
          />
          <Text className="text-text-secondary">No preview</Text>
        </View>
      </View>
    );
  }

  return (
    <ExpoImage
      {...props}
      placeholder={{
        uri: "thumbhash:/1QcSHQRnh493V4dIh4eXh1h4kJUI",
      }}
      onError={(e) => {
        setError(!!e);
      }}
    />
  );
}
